import { cart, suggestion } from "../Data";

const initialState = {
  cart: cart,
  suggestion: suggestion,
};
export default initialState;
